<template>
  <div class="mt-5 ">
    <div class="container-fluid fr">
      <div class="row">
        <div class="col-12">
          <span class="blog-title-card">Projects</span> <br>
          <span class="blog-title">My Creative</span>
        </div>
      </div>
      <div class="row mt-3">
        <!--        Blog Image -->
        <div class="col-12 col-md-12 col-lg-4" v-for="(b,index) in data" :key="index">
          <div class="grid d-flex flex-column mt-3" >
            <figure class="effect-lily" >
              <img :src="b.image" alt="img12" />
              <figcaption>
                <div>
                  <p class="fs-">{{ b.date }}</p>
                </div>
              </figcaption>
            </figure>
            <div class="text-start p-3">
              <span class="text-black-50 fw-bolder">
                {{ b.title }}
              </span>
              <div class="dropdown-divider montserrat-font" ></div>
              <p class="text-black-50">
                {{ b.desc }}
              </p>
              <a :href="b.link" target="_blank" class="btn btn-outline-dark btn-sm" >
                <span class="fw-bold">
                   go
                </span>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <!--        Blog Image-->
      </div>
    </div>

    <b-modal id="modal-1" size="lg" hide-header hide-footer title="BootstrapVue">
      <p class="my-4">Hello from modal!</p>
    </b-modal>

  </div>
</template>

<script>
import {collection, getDocs} from "firebase/firestore";
import db from "@/firebase";

export default {
  name: "Projects",
  data() {
    return {
      data : [],
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const ColRef = collection(db, "projects");
      let SnapShot = await getDocs(ColRef);
      let data = [];
      SnapShot.forEach(el => {
        let Data = el.data();
        Data.id = el.id;
        data.push(Data);
      });
      this.data = data;
    },
  },
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap');

/* Common style */
.grid {
  border : 1px solid var(--border);
  border-radius: 5px;
}

.grid figure {
  position: relative;
  float: left;
  overflow: hidden;
  margin: 10px 1%;
  text-align: center;
  cursor: pointer;
}

.grid figure img {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Anchor will cover the whole item by default */
/* For some effects it will show as a button */
.grid figure figcaption > a {
  z-index: 1000;
  text-indent: 200%;
  white-space: nowrap;
  font-size: 0;
  opacity: 0;
}

.grid figure h2 {
  word-spacing: -0.15em;
  font-weight: 300;
}

.grid figure h2 span {
  font-weight: 800;
}

.grid figure h2,
.grid figure p {
  margin: 0;
}

.grid figure p {
  letter-spacing: 1px;
  font-size: 68.5%;
}

/* Individual effects */

/*---------------*/
/***** Lily *****/
/*---------------*/

figure.effect-lily img {
  max-width: none;
  width: -webkit-calc(100% + 50px);
  width: calc(100% + 50px);
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(-20px,0, 0);
  transform: translate3d(-20px,0,0);
}

figure.effect-lily figcaption {
  text-align: left;
}

figure.effect-lily figcaption > div {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 2em;
  width: 100%;
  height: 50%;
}

figure.effect-lily h2,
figure.effect-lily p {
  -webkit-transform: translate3d(0,40px,0);
  transform: translate3d(0,40px,0);
}

figure.effect-lily h2 {
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
}

figure.effect-lily p {
  opacity: 0;
  color: var(--light);
  font-weight: bolder;
  -webkit-transition: opacity 0.2s, -webkit-transform 0.35s;
  transition: opacity 0.2s, transform 0.35s;
}

figure.effect-lily:hover img,
figure.effect-lily:hover p {
  opacity: 1;
}

figure.effect-lily:hover img,
figure.effect-lily:hover h2,
figure.effect-lily:hover p {
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}

figure.effect-lily:hover p {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
  -webkit-transition-duration: 0.35s;
  transition-duration: 0.35s;
}
</style>